var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconColorSave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-save",
    "data-name": "Icon material-save",
    d: "M18.5,4.5H6.5a2,2,0,0,0-2,2v14a2,2,0,0,0,2,2h14a2.006,2.006,0,0,0,2-2V8.5Zm-5,16a3,3,0,1,1,3-3A3,3,0,0,1,13.5,20.5Zm3-10H6.5v-4h10Z",
    transform: "translate(-4.5 -4.5)",
    fill: "#00aec7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconColorSave);
export default __webpack_public_path__ + "static/media/icon-color-save.6b5cfe214feb944fee08da0e82d5f638.svg";
export { ForwardRef as ReactComponent };